import PropTypes from 'prop-types';

import { getPagePath, trans, useSoyuzLocales } from '@spotahome/soyuz/client';

import FooterBlock from './components/FooterBlock';
import FooterBlockTitle from './components/FooterBlockTitle';
import FooterBlockList from './components/FooterBlockList';
import FooterLink from './components/FooterLink';

const JoinUsFooter = ({ linkTheme }) => {
  const { current: currentLocale } = useSoyuzLocales();

  const joinUsLinks = [
    {
      url: getPagePath('landings.collaborators'),
      transKey: 'footer.item.collaborators'
    },
    {
      url: getPagePath('landings.become-partner'),
      transKey: 'footer.item.become_partner'
    },
    {
      url: getPagePath('externals.work-with-us'),
      transKey: 'footer.item.work_with_us'
    },
    {
      url: getPagePath('externals.landingi.rewards-program'),
      transKey: 'footer.item.rewards_program',
      locales: ['en', 'es']
    }
  ];

  return (
    <FooterBlock>
      <FooterBlockTitle text={trans('footer.join-us')} />
      <FooterBlockList>
        {joinUsLinks.map(({ transKey, url, locales }) =>
          !locales || locales.includes(currentLocale) ? (
            <FooterLink key={transKey} linkTheme={linkTheme} href={url}>
              {trans(transKey)}
            </FooterLink>
          ) : null
        )}
      </FooterBlockList>
    </FooterBlock>
  );
};

JoinUsFooter.propTypes = {
  linkTheme: PropTypes.string.isRequired
};

export default JoinUsFooter;
